<template>
  <!-- 应用——数据看板 -->
  <div class="enterpriseBoard">
    <div class="head">
      <el-menu :default-active="boardType" mode="horizontal" active-text-color="var(--theme-color)" @select="changeBoard">
        <el-menu-item index="0">项目一览</el-menu-item>
        <el-menu-item index="1">质量看板</el-menu-item>
        <el-menu-item index="2">人员看板</el-menu-item>
        <el-menu-item index="3">进度看板</el-menu-item>
        <el-menu-item index="4">运行指标</el-menu-item>
      </el-menu>
      <el-button v-show="false" type="primary" size="small" class="exportPPT" :loading="loadingPPT" @click="exportPPT">
        导出PPT
      </el-button>
      <el-button v-show="false" type="primary" size="small" class="exportExcel" :loading="loadingExcel"
        @click="exportExcel">
        导出Excel
      </el-button>
    </div>
    <div class="content">
      <!-- 项目一览 -->
      <template v-if="boardType == '0'">
        <projectAllSee ref="projectAllSee"></projectAllSee>
      </template>
      <!-- 质量看板 -->
      <template v-if="boardType == '1'">
        <qualityBoard ref="qualityBoard"></qualityBoard>
      </template>
      <!-- 人员看板 -->
      <template v-if="boardType == '2'">
        <staffBoard ref="staffBoard"></staffBoard>
      </template>
      <!-- 进度看板 -->
      <template v-if="boardType == '3'">
        <progressBoard ref="progressBoard"></progressBoard>
      </template>
      <!-- 活跃度 -->
      <template v-if="boardType == '4'">
        <activation ref="progressBoard"></activation>
      </template>
    </div>

  </div>
</template>

<script>
import projectAllSee from "./components/projectAllSee.vue";
import qualityBoard from "./components/qualityBoard.vue";
import staffBoard from "./components/staffBoard.vue";
import progressBoard from "./components/progressBoard.vue";
import activation from "./components/activation.vue";

export default {
  name: "EnterpriseBoard",
  components: { projectAllSee, qualityBoard, staffBoard, progressBoard, activation },
  data() {
    return {
      boardType: "0", // 当前看板类型
      loadingPPT: false,
      loadingExcel: false
    };
  },
  mounted() {},
  methods: {
    // 切换看板
    changeBoard(index) {
      this.boardType = index;
    },

    // 看板导出PPT
    exportPPT() {
      this.loadingPPT = true;
      try {
        if (this.boardType == 0) this.$refs.projectAllSee.exportPPT();
        if (this.boardType == 1) this.$refs.qualityBoard.exportPPT();
        if (this.boardType == 2) this.$refs.staffBoard.exportPPT();
        if (this.boardType == 3) this.$refs.progressBoard.exportPPT();
      } finally {
        this.loadingPPT = false;
      }
    },
    // 看板导出Excel
    exportExcel() {
      this.loadingExcel = true;
      try {
        if (this.boardType == 0) this.$refs.projectAllSee.exportExcel();
        if (this.boardType == 1) this.$refs.qualityBoard.exportExcel();
        if (this.boardType == 2) this.$refs.staffBoard.exportExcel();
        if (this.boardType == 3) this.$refs.progressBoard.exportExcel();
      } finally {
        this.loadingExcel = false;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.enterpriseBoard {
  width: 100%;
  padding: var(--middle-space);
  height: 100%;
  display: flex;
  flex-direction: column;
  .head {
    width: 100%;
    background-color: white;
    border-radius: 4px 4px 0 0;
    overflow: hidden;
    position: relative;

    .el-menu {
      padding-left: var(--big-space);
      border-bottom: 1px solid #e6eaf8;

      .el-menu-item {
        height: 46px;
        padding: 0;
        margin: 0 40px 0 0;
        font-family: "PingFang SC";
        font-weight: 700;
        font-size: 16px;
        line-height: 46px;
      }
    }

    .exportPPT {
      position: absolute;
      top: 7px;
      right: 123px;
    }

    .exportExcel {
      position: absolute;
      top: 7px;
      right: 23px;
    }
  }
  .content{
    height: 1px;
    flex-grow: 1;
  }
}
</style>
